"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
const MessageRef_1 = __importDefault(require("./MessageRef"));
/**
 * Strict messageRef that requires sequenceNumber to be set
 */
class MessageRefStrict extends MessageRef_1.default {
    constructor(timestamp, sequenceNumber) {
        super(timestamp, sequenceNumber);
        validations_1.validateIsNotNegativeInteger('sequenceNumber', sequenceNumber);
    }
}
exports.default = MessageRefStrict;
//# sourceMappingURL=MessageRefStrict.js.map